import { Typography } from '@mui/material'
import React from 'react'

import { Container, Content } from './common'

const Invalid: React.FC = () => (
  <Container>
    <Content>
      <Typography className="invitation-message-text" variant="h5" textAlign="center">
        The invitation is invalid. Make sure you're opening a valid active invitation.
        <br />
        If you need further assistance, kindly contact customer support.
      </Typography>
    </Content>
  </Container>
)

export default Invalid
